import {AuthInternalApi} from 'app/core/data/auth/api';
import {UserInternalApi} from 'app/core/data/user/api';
import {HelpCenterInternalApi} from 'app/core/data/help-center/api';

export const internalApiServices = [
    AuthInternalApi,
    HelpCenterInternalApi,
    UserInternalApi
];
